module.exports = __webpack_public_path__ + "media/images/error/403-054eac720625b66aa917c2e65f3b7465.png";